import { Code } from "lucide-react"

export const DevMenu = () => (
  <nav
    aria-label="Development menu"
    className="group absolute -left-16 size-14 cursor-pointer flex-col text-gray-700 hover:size-auto lg:flex"
  >
    <div className="flex flex-row">
      <div className="flex items-center p-3 group-hover:bg-gray-600 group-hover:text-white">
        <Code name="Code icon" strokeWidth="1.5" className="size-6" />
      </div>
      <div className="flex grow bg-transparent" />
    </div>

    <div className="hidden flex-col group-hover:flex group-hover:bg-gray-600 group-hover:text-white">
      <a href="/?u=Author" className="p-3 pr-9 text-white hover:bg-gray-100 hover:text-black">
        Author
      </a>
      <a href="/?u=Editor" className="p-3 pr-9 text-white hover:bg-gray-100 hover:text-black">
        Editor
      </a>
      <a href="/?u=Reader" className="p-3 pr-9 text-white hover:bg-gray-100 hover:text-black">
        Reader
      </a>
    </div>
  </nav>
)
